import { IntlShape, useIntl } from 'react-intl';

import { logOut } from '@marketplace/common';
import { Dialog } from '@marketplace/ui-elements';
import classes from './modal-for-deacrivated-user.module.scss';

export const ModalForDeactivatedUser = (): JSX.Element => {
  const { formatMessage }: IntlShape = useIntl();

  const handleRejectForm = async () => {
    await logOut();
  };

  return (
    <Dialog
      visible
      rootClassName={classes.dialog}
      header={formatMessage({
        id: 'developer_landing_deactivated_user_dialog_title',
      })}
      rejectLabel={formatMessage({
        id: 'developer_landing_auth_dialog_btn_cancel',
      })}
      acceptLabel={formatMessage({
        id: 'developer_landing_auth_dialog_btn_submit',
      })}
      onReject={handleRejectForm}
    >
      <div className={classes.message}>
        {formatMessage({
          id: 'developer_landing_deactivated_user_dialog_message',
        })}
      </div>
    </Dialog>
  );
};
